import * as React from 'react';
import Box from '@mui/material/Box';

export const  TabPanel = (props) => {
  const { children, value, index, costumStyle,...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3}} style={{...costumStyle}}>
          {children}
        </Box>
      )}
    </div>
  );
}


